<template>
   <div class="form-group form-check" role="listitem">
      <input :id="domId" v-model="checkState" type="checkbox" class="form-check-input" />
      <label v-if="isEducation" :for="domId" class="form-check-label"
         >{{ educationCaption }}<br v-if="educationSubtitle" />
         <small>{{ educationSubtitle }}</small>
      </label>
      <label
         v-popover
         v-else
         :for="domId"
         :title="label"
         :data-content="secondary"
         class="form-check-label"
         data-container="body"
         data-trigger="hover"
         data-toggle="popover"
         data-placement="right"
         >{{ label }}
         <div v-if="isDomain" :class="`cat-${shortDomainName}`" aria-hidden="true"></div>
      </label>
   </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
export default {
   name: 'FilterItem',
   props: ['id', 'group', 'label', 'secondary', 'shortDomainName'],
   computed: {
      domId: function () {
         return `${this.group}-${this.id}`;
      },
      isCompetency: function () {
         return this.group === 'competency';
      },
      isJobLevel: function () {
         return this.group === 'level';
      },
      isEducation: function () {
         return this.group === 'education';
      },
      isDomain: function () {
         return this.group === 'domain';
      },
      education: function () {
         const suffix = ' or equivalent experience';
         if (!this.isEducation) return null;
         const i = this.label.indexOf(suffix);
         return i > 0 ? [this.label.substring(0, i), suffix] : [this.label];
      },
      educationCaption: function () {
         if (!this.isEducation) return null;
         return this.education[0];
      },
      educationSubtitle: function () {
         if (!this.isEducation) return null;
         return this.education[1];
      },
      competenciesCount: function () {
         return this.$store.getters['filters/selectedCompetencies'].length;
      },
      levelsCount: function () {
         return this.$store.getters['filters/selectedLevels'].length;
      },
      educationCount: function () {
         return this.$store.getters['filters/selectedEducation'].length;
      },
      domainsCount: function () {
         return this.$store.getters['filters/selectedDomains'].length;
      },
      checkState: {
         get() {
            return this.$store.state.filters[this.group][this.id].checked;
         },
         set(val) {
            this.$store.commit('filters/setCheckState', {
               group: this.group,
               id: this.id,
               val: val,
            });
            // if we now have no filters set
            // including freetext
            // navigate to the categories page
            if (
               !this.$store.state.filters.freetext &&
               this.competenciesCount === 0 &&
               this.levelsCount === 0 &&
               this.educationCount === 0 &&
               this.domainsCount === 0
            ) {
               // console.log('need to do a clear all!');
               this.$store.commit('filters/clearAll');
               this.$router.push({path: 'categories'});
            }
         },
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterItem.vue